import React from 'react';
import { motion } from 'framer-motion';
import HeroV3 from '../components/HeroV3';
import PhilosophyV3 from '../components/PhilosophyV3';
import SystemsV3 from '../components/SystemsV3';
import ArchitectureDeepDiveV3 from '../components/ArchitectureDeepDiveV3';
import ImpactMetricsV3 from '../components/ImpactMetricsV3';
import ProjectsV3 from '../components/ProjectsV3';
import ExperienceV3 from '../components/ExperienceV3';
import WritingV3 from '../components/WritingV3';
import OpenSourceV3 from '../components/OpenSourceV3';
import ContactV3 from '../components/ContactV3';
import FooterV3 from '../components/FooterV3';

const SectionWrap = ({ children, index }) => (
  <motion.section
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: index * 0.04 }}
    viewport={{ once: true, amount: 0.15 }}
    className="max-w-6xl mx-auto px-6 py-24"
  >
    {children}
  </motion.section>
);

const PortfolioV3 = () => {
  const sections = [
    <HeroV3 />,
    <PhilosophyV3 />,
    <SystemsV3 />,
    <ArchitectureDeepDiveV3 />,
    <ImpactMetricsV3 />,
    <ProjectsV3 />,
    <ExperienceV3 />,
    <WritingV3 />,
    <OpenSourceV3 />,
    <ContactV3 />,
  ];

  return (
    <div className="min-h-screen bg-white">
      <main>
        {sections.map((section, index) => (
          <SectionWrap key={index} index={index}>
            {section}
          </SectionWrap>
        ))}
        <FooterV3 />
      </main>
    </div>
  );
};

export default PortfolioV3;
